/**
 * Theme switching — persists to localStorage and applies a `data-theme`
 * attribute on <html>. All colors flow from CSS variables, so switching is
 * instant and requires no re-render.
 */
export type Theme = 'dark' | 'light';

const KEY = 'zangle-theme';

export function getStoredTheme(): Theme {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(theme: Theme): void {
  if (theme === 'dark') {
    delete document.documentElement.dataset.theme;
  } else {
    document.documentElement.dataset.theme = theme;
  }
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* private mode — ignore */
  }
}